const ACTIVE_STATES = new Set(['requested', 'validating', 'waiting_for_input', 'queued', 'running', 'retry_requested']);
const SUCCESS_STATES = new Set(['succeeded']);
const FAILURE_STATES = new Set(['failed', 'cancelled']);

export const getWorkflowRows = (snapshot) => {
  if (!snapshot) return [];
  if (Array.isArray(snapshot?.workflows)) return snapshot.workflows;
  if (Array.isArray(snapshot?.snapshot?.workflows)) return snapshot.snapshot.workflows;
  return [];
};

export const findWorkflowSnapshot = (snapshot, workflowType, channel) => {
  const typeKey = String(workflowType || '').trim().toLowerCase();
  const channelKey = String(channel || 'default').trim().toLowerCase();

  if (!typeKey) return null;

  return getWorkflowRows(snapshot).find((row) => {
    const rowType = String(row?.workflow_type || '').trim().toLowerCase();
    const rowChannel = String(row?.channel || 'default').trim().toLowerCase();
    return rowType === typeKey && rowChannel === channelKey;
  }) || null;
};

export const workflowStateToLegacyStatus = (row) => {
  const state = String(row?.state || '').trim().toLowerCase();
  if (ACTIVE_STATES.has(state)) return 'processing';
  if (SUCCESS_STATES.has(state)) return 'complete';
  if (FAILURE_STATES.has(state)) return 'failed';
  if (state === 'idle') return 'not_started';
  return row ? 'not_started' : null;
};

export const workflowStateToVisibleStatus = (row) => {
  const legacyStatus = workflowStateToLegacyStatus(row);
  if (legacyStatus === 'complete') return 'success';
  return legacyStatus;
};

export const workflowCount = (row, keys = []) => {
  const counts = row?.counts && typeof row.counts === 'object' ? row.counts : {};
  for (const key of keys) {
    const value = Number(counts[key]);
    if (Number.isFinite(value) && value > 0) return value;
  }
  return 0;
};

export const workflowSyntheticLog = (row, fallbackMessage = 'Workflow status updated.') => {
  if (!row) return null;

  const status = workflowStateToLegacyStatus(row);
  const message = row.status_label || row.reason || fallbackMessage;
  const logType = status === 'failed' ? 'error' : status === 'complete' ? 'success' : 'info';

  return {
    message,
    logMessage: message,
    logType,
    type: logType,
    status: status === 'complete' ? 'completed' : status === 'failed' ? 'error' : 'in_progress',
    timestamp: row.updated_at || new Date().toISOString(),
    workflow_type: row.workflow_type,
    platform: row.channel,
  };
};
